import { setUnreadListFailed, setUnreadListPending, setUnreadListSucceed } from './actions';
import { transformItemListChatV1 } from '../../mappers/transformItemListChatV1';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchUnreadChats } from '../../services/fetchUnreadChats';
import { CHATS_ON_PAGE_LIMIT } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { IChatListRequest } from '../chatList/types';
import { setRoute } from '../route';

/**
 * Получить список непрочитанных чатов
 * FIXME: Пока ручки для получения всех непрочитанных нет, берем из обычных чатов
 */
export const getUnreadChats =
  ({ timestamp }: IChatListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setUnreadListPending({ timestamp }));

    const unreadChats = await fetchUnreadChats(context, {
      parameters: {
        limit: CHATS_ON_PAGE_LIMIT,
        timestampMs: timestamp,
        subAgentRealtyUserId,
      },
    });

    if (!unreadChats) {
      dispatch(setUnreadListFailed());

      return;
    }

    const chats = unreadChats.map(transformItemListChatV1);
    dispatch(setUnreadListSucceed(chats));

    /**
     * Ставим активный пункт меню - сообщения
     */
    dispatch(setRoute({ route: ERoute.Unread }));
  };
